import moment from 'moment';

const to12HourInterpreter = timeString => moment(timeString, 'h:mm').format('LT');

export default to12HourInterpreter;
